<template>

  <nav id="nav" class="navbar navbar-expand-lg navbar-light sticky-top p-0">
    <div class="container">

        <a class="navbar-brand m-0" href="#">
            <router-link to="/" class="nav-link">
                <img class="rounded-circle shadow" src="https://i.ibb.co/Fn12M3x/ond-Estudo-c-pia.png" width="75" height="75">
            </router-link>
        </a>

        <ul class="navbar-nav d-flex align-items-center">
            <button type="button" class="btn btn-light mr-3" data-toggle="modal" data-target="#exampleModal">
              Download
            </button>
        </ul>
        
    </div>
  </nav>

    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <img class="shadow w-100" src="https://i.ibb.co/P4FN77b/Qr-Code-2-Zao0.png">
            <a href="https://play.google.com/store/apps/details?id=com.roft.ondestudo" target="_blank" class="d-flex justify-content-center">
                <img class="playButton m-auto pt-4" src="https://i.ibb.co/QCqqDQ6/playstore.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

  <div class="py-4">
      <router-view/>
  </div>

    <footer class="page-footer font-small">
        <!-- Footer Elements -->
        <div class="container">
            <!-- Social buttons -->
            <ul class="list-unstyled list-inline text-center d-flex justify-content-center">
                <li class="list-inline-item">
                    <a href="https://www.instagram.com/roftsoftware" target="_blank">
                        <img src="https://i.ibb.co/9tK9181/instagram.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://twitter.com/RoftSoftware" target="_blank">
                        <img src="https://i.ibb.co/QpyqB2W/twitter.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://www.pinterest.pt/roftcomp/_saved/" target="_blank">
                        <img src="https://i.ibb.co/9pyQqQ6/pinterest-1.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://gumroad.com/roft" target="_blank">
                        <img src="https://i.ibb.co/RYKNWcT/shopping-bag.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="mailto:roft.comp@gmail.com">
                        <img src="https://i.ibb.co/zJRQGP9/google.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://play.google.com/store/apps/developer?id=ROFT" target="_blank">
                        <img src="https://i.ibb.co/TcKXkMR/playstore.png" class="social-icon" />
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://github.com/ribeiro1505" target="_blank">
                        <img src="https://i.ibb.co/0q3jwL3/github.png" class="social-icon" />
                    </a>
                </li>
            </ul>
            <!-- Social buttons -->
        </div>
        <!-- Footer Elements -->
        <div class="footer-copyright text-center py-3"> © 2021 <a href="https://roft.eu/" target="_blank" style="color:black">ROFT</a>. All Rights Reserved.</div>
    </footer>

</template>

<script>
export default {
mounted() {
      this.$nextTick(function(){
        window.addEventListener("scroll", function(){
          var navbar = document.getElementById("nav");
          var nav_classes = navbar.classList;
          if(document.documentElement.scrollTop >= 150) {
            if (nav_classes.contains("shrink") === false) {
              nav_classes.toggle("shrink");
            }
          }
          else {
            if (nav_classes.contains("shrink") === true) {
              nav_classes.toggle("shrink");
            }
          }
        })
      })
    },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

html body {
    background-color: #6bb5ff;
}

nav {
  transition: all 0.5s;
}

nav.shrink {
  background: rgb(0,0,0,0.2);
}

.social-icon{
    height: 20px;
}

.list-inline-item{
    margin-left: 2vw;
    margin-right: 2vw;
}

.playButton{
  width: 150px;
  height: 100%;
}
</style>
